<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-06 15:49:36
 * @LastEditTime: 2020-10-30 15:26:27
 * @LastEditors: Please set LastEditors
 -->
// 综合看板---首页
<template>
    <div class="globalPage">
        <!-- 顶部标题 -->
        <div class="gp_header">
            <div class="gp_header_main">
                <!-- 顶部左侧信息 -->
                <div class="left_header">
                    <!-- 用户名 -->
                    <div class="user_info">
                        <div class="user_welcome">欢迎您，{{userInfo.username}}</div>
                        <el-tooltip
                            class="user_welcome_tooltip"
                            :content="userInfo.username"
                            placement="top"
                        ></el-tooltip>
                        <div class="user_logout">
                            <el-button class="logout_btn" size="mini" @click="logoutFunc">退出</el-button>
                        </div>
                    </div>
                    <!-- 日期 -->
                    <div class="date_info">
                        <div class="date_now">{{nowTimeStr}}</div>
                    </div>
                </div>
                <!-- 顶部中间标题 -->
                <div class="center_title">
                    <p @click="titleClick">设备远程运维系统</p>
                </div>
            </div>
        </div>
        <!-- 主要内容 -->
        <div class="gp_body">
            <!-- 上方区域 -->
            <div class="gp_body_top">
                <!-- 左侧地图区域 -->
                <div class="map_section">
                    <div class="ct_section">
                        <div class="ct_section_main">
                            <div class="ct_title_globalPage">
                                <div class="title_syItem">|&nbsp;&nbsp;&nbsp;&nbsp;地图展示</div>
                                <div class="btnBox_syItem">
                                    <el-button
                                        class="btn__syItem"
                                        @click="fullScreenClick"
                                        type="primary"
                                        size="mini"
                                    >全屏</el-button>
                                </div>
                            </div>
                            <div class="ct_content_globalPage">
                                <!-- 地图组件 -->
                                <deviceMap domIdStr="xp"></deviceMap>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右侧组合区域 -->
                <div class="right_mix_section">
                    <!-- 设备状态 和 总产能 -->
                    <div class="top_mix_section">
                        <!-- 设备状态 -->
                        <div class="ct_section">
                            <div class="ct_section_main">
                                <div class="ct_title_globalPage">
                                    <div class="title_syItem">|&nbsp;&nbsp;&nbsp;&nbsp;设备状态统计</div>
                                </div>
                                <div class="ct_content_globalPage circleBox">
                                    <div class="oneLine flex row center oneLineTwo">
                                        <!-- <div class="oneBox flex center middle cf txtc">
                                            <span>
                                                <b>{{info.warnNum}}</b>
                                                <br />预警
                                            </span>
                                        </div> -->
                                        <div class="oneBox alarmBox flex center middle cf txtc" @click="toAlarmPage()">
                                            <span>
                                                <b>{{info.alarmNum}}</b>
                                                <br />报警
                                            </span>
                                        </div>
                                        <!-- <div
                                            class="oneBox faultBox threeBox flex center middle cf txtc"
                                        >
                                            <span>
                                                <b>{{info.faultNum}}</b>
                                                <br />
                                            </span>
                                        </div> -->
                                    </div>
                                    <div class="twoLine flex row between">
                                        <div
                                            class="oneBox twoLineBox runBox flex center middle cf txtc"
                                        >
                                            <span>
                                                <b>{{info.runNum}}</b>
                                                <br />生产
                                            </span>
                                        </div>
                                        <div
                                            class="oneBox twoLineBox awaitBox flex center middle cf txtc"
                                        >
                                            <span>
                                                <b>{{info.freeNum}}</b>
                                                <br />待机
                                            </span>
                                        </div>
                                        <div
                                            class="oneBox twoLineBox awaitBox flex center middle cf txtc"
                                        >
                                            <span>
                                                <b>{{info.stopNum}}</b>
                                                <br />关机
                                            </span>
                                        </div>
                                        <div
                                            class="oneBox twoLineBox awaitBox flex center middle cf txtc"
                                        >
                                            <span>
                                                <b>{{info.faultNum}}</b>
                                                <br />故障
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 总开机时间 和 维修工单 -->
                    <div class="botm_mix_section">
                        <!-- 总开机时间 -->
                        <div class="totalOnTime_section">
                            <div class="ct_section">
                                <div class="ct_section_main">
                                    <div class="ct_title_globalPage">
                                        <div class="title_syItem">|&nbsp;&nbsp;&nbsp;&nbsp;生产时长排名前三</div>
                                    </div>
                                    <div class="ct_content_globalPage ct_flex flex between">
                                        <div class="oneLineProgress" v-for="(item, index) in progress" :key="'aa'+ index">
                                            <div class="lineTxt flex between fz10">
                                                <span class="c0b9">{{item.name}}</span>
                                                <span class="ce59">{{item.time}}</span>
                                            </div>
                                            <div  class="progress" :class="`progress${index}`">
                                                <span :style="{'width':'calc('+item.percent+' - 4px)'}"></span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 维修工单 -->
                        <div class="maintenanceOrder_section">
                            <div class="maintenanceOrder_section_main">
                                <div class="ct_section">
                                    <div class="ct_section_main">
                                        <div class="ct_title_globalPage">
                                            <div
                                                class="title_syItem"
                                            >|&nbsp;&nbsp;&nbsp;&nbsp;设备各地分布</div>
                                        </div>
                                        <div class="ct_content_globalPage">
                                            <div class="echarts_dom" id="mainCityEcharts"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 下方区域 -->
            <div class="gp_body_botm">
                <!-- 项目列表 -->
                <div class="projectList_section projectList_sectionLongBg">
                    <div class="ct_section">
                        <div class="ct_section_main">
                            <div class="ct_title_globalPage mt10">
                                <div class="title_syItem">|&nbsp;&nbsp;&nbsp;&nbsp;设备列表</div>
                            </div>
                            <div class="ct_content_globalPage">
                               <div class="listThead cf pl10 pr10 c00c">
                                  <span>设备名称</span><span>设备地区</span><span>设备编码</span><span>设备状态</span><span>今日切割长度</span>
                               </div>
                               <div class="tableScroll mt20">
                                <vue-seamless-scroll :data="deviceData" class="warp"  :class-option="classOption">
                                  <ul class="item cf " ref="listItem">
                                    <li v-for="(item, index) in deviceData" :key="'aaa'+ index" class="listScroll">
                                      <span class="title">{{item.gatewayName}}</span><span class="title">{{item.province}}-{{item.city}}</span><span class="title">{{item.imei}}</span><span class="title">{{item.onlineFlag==='1' ? '在线' : '离线'}}</span><span class="title">{{parseFloat(item.areaLength).toFixed(2)}}mm</span>
                                    </li>
                                  </ul>
                                </vue-seamless-scroll>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 报警信息 -->
                <div class="alarm_section">
                    <div class="ct_section ct_sectionBg">
                        <div class="ct_section_main">
                            <div class="ct_title_globalPage mt10">
                                <div class="title_syItem">|&nbsp;&nbsp;&nbsp;&nbsp;每月销售数据</div>
                            </div>
                            <div class="ct_content_globalPage" >
                               <div id="monthEcharts"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 对话框容器 -->
        <div class="dialog_container">
            <!-- 全屏地图 -->
            <el-dialog
                title="全屏地图"
                :visible.sync="fullScreenMapDialogShow"
                fullscreen
                center
                class="fullScreenMap"
                custom-class="tanChuang"
                :before-close="fullScreenMapClose"
                top="0px"
            >
                <!-- 地图组件 -->
                <deviceMap v-if="qpMapShow" domIdStr="Qp" isSetCenter="true" mapLevel="1"></deviceMap>
            </el-dialog>
        </div>
    </div>
</template>
<script>
// 引入工具类
import utils from '@/util/utilsHome';
import $ from 'jquery';
// 引入绘制echarts图表
import {renderOptions} from '@/util/bigScreenCharts';
import {secondToHour} from '@/util/tools'
import { mapGetters } from 'vuex';
// 引入api
import { deviceListMapInfo,statisState,statisWork,distributionData,statisSales } from '@/api/overview/bigScreen.js';
// 引入子组件
import deviceMap from './deviceMap'; // 地图组件
const moment = require('moment');
import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
    name: 'globalPage',
    data() {
        return {
            nowTimeStr: '', // 日期时间
            // 全屏地图 对话框相关
            fullScreenMapDialogShow: false, // 全屏地图对话框显示状态
            qpMapShow: false, // 地图组件（全屏）显示状态：目的是显示的时候重新加载子组件，刷新子组件数据
            listData: [
              {value: '1dffsfsfs'},
              {value: '2sfdfsfsf'},
              {value: '342432434的士速遞sad'},
              {value: '442432434的士速遞sad'},
              {value: '542432434的淡定點士速遞sad'}
            ],
            deviceData:[], // 设备列表
            progress:[], // 进度条
            info:{},  //设备状态统计
            cityData: [], //城市分布
            saleData: [] // 销售数据
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem('ms_username');
            return username ? username : this.name;
        },
        classOption () {
          return {
            step: 0.2,
            limitMoveNum:4,//这个是修改moveSwitch()之前的使用方法，这里的数值指的是数据条数
            openTouch: false,
            singleHeight: 25,
            waitTime: 0
          }
        },
        ...mapGetters(['userInfo'])
    },
    components: {
        deviceMap,
        vueSeamlessScroll
    },
    created() {
        this.nowTimeStr = moment().format('YYYY-MM-DD');
    },
    mounted() {
        // 初始化先隐藏设备信息面板
        $('#devicepanel').hide();
        // this.$store.dispatch('GetUserInfo');
        this.querydeviceList()
        this.queryInfo()
        this.queryLongTime()
        this.queryCityData()
        this.querySaleData()
    },

    methods: {
        /*
         * 方法函数
         */
        // 点击 顶部标题
        titleClick() {
            // 跳转到index页面
            this.$router.push('/wel/index');
        },
        // 退出登录
        logoutFunc() {
            // 清除浏览器本地存储中的所有数据
            utils.sessionClearStore();

            this.$store.dispatch('LogOut').then(() => {
                this.$router.push({ path: '/login' });
            });
            // 跳转到登录页面---刷新页面后，因为userId被清空，路由拦截会自动跳转到登录页，所以不需要添加下面这行代码。
            // this.$router.push('/login')
        },
        drawBarChart(id, options) {
            // console.log(options, 'optionss-')
            let myChart = echarts.init(document.getElementById(id));
            // 使用 aidState做填充，fakeState显示小线条
            myChart.showLoading({
                text: '正在加载...'
            });
            myChart.hideLoading();
            myChart.setOption(options, (window.onresize = myChart.resize));
        },
        // 点击 地图展示的 全屏
        fullScreenClick() {
            // 全屏地图对话框显示状态---显示
            this.fullScreenMapDialogShow = true;
            // 地图组件（全屏）显示状态---显示
            this.qpMapShow = true;
        },
        // 点击关闭 全屏地图 对话框
        fullScreenMapClose(done) {
            // 地图组件（全屏）显示状态---隐藏
            this.qpMapShow = false;
            // 关闭对话框
            done();
        },
        toAlarmPage () {
            this.$router.push('/deviceManage');
        },
        querydeviceList () {
          deviceListMapInfo().then(res=>{
            if (res.data.code === 200) {
              console.log(res.data.data)
              this.deviceData = res.data.data
            } else {
              this.$message.error(res.data.msg);
              return;
            }
          })
        },
        queryInfo () {
          statisState().then(res=>{
            if (res.data.code === 200) {
              // console.log(res.data.data)
              this.info = res.data.data
            } else {
              this.$message.error(res.data.msg);
              return;
            }
          })
        },
        queryLongTime () {
          statisWork().then(res=>{
            if (res.data.code === 200) {
              const {data} = res.data
              let len = (data.length >= 4) ? 3 : data.length
              this.progress = []
              // console.log(data[0],' ---data[0]-')
              let count = data[0].runLength + (data[1] ? data[1].runLength : 0) + (data[2] ? data[2].runLength : 0)
              for(let i =0;i<len;i++) {
                  let obj = {}
                  obj.name = data[i].name
                //   if (i == 1) {
                //     console.log(data[i].runLength, 'aaass',secondToHour(data[i].runLength),'secondToHour')   
                //   }
                 // debugger
                   obj.time = secondToHour(data[i].runLength)
                  obj.percent = ((data[i].runLength/data[i].totalLength)*100).toFixed(2)+'%'
                  this.progress.push(obj)
              }
            } else {
              this.$message.error(res.data.msg);
              return;
            }
          })
        },
        queryCityData () {
          distributionData().then(res=>{
            if (res.data.code === 200) {
              const {data} = res.data
              let len = (data.length >= 5) ? 5 : data.length
              this.cityData = res.data.data
              let xAxisAry = [], serialAry =[]
              for(let i = 0 ; i <len;i++) {
                  xAxisAry.push(data[i].province)
                  serialAry.push(data[i].num)
              }
              let serial = [{
                    name: '设备分布',
                    type: 'bar',
                    barWidth:20,
                    itemStyle:{
                         barBorderRadius: '5,5,0,0'
                    },
                    data:serialAry
              }]
              let tipsformatter = '{b}<br/>{a}:{c}' + '台'
              let options = renderOptions({xAxis: xAxisAry,series: serial,tipsformatter})
              this.drawBarChart('mainCityEcharts', options);
            } else {
              this.$message.error(res.data.msg);
              return;
            }
          })
        },
        querySaleData() {
            statisSales().then(res=>{
                if (res.data.code === 200) {
                    if (!res.data.data.length) {
                        return
                    }
                    this.saleData = res.data.data
                    const {data} = res.data
                    let xAxisAry = [], serialAry =[]
                    for(let i = 0 ; i <data.length;i++) {
                        xAxisAry.push(data[i].time)
                        serialAry.push(data[i].num)
                    }
                    let serial = [{
                            name: '',
                            type: 'bar',
                            barWidth:20,
                            data:serialAry
                    }]
                    let tipsformatter = '{b}:{c}' + '台'
                    let options = renderOptions({xAxis: xAxisAry,series: serial,tipsformatter})
                    this.drawBarChart('monthEcharts', options);
                } else {
                    this.$message.error(res.data.msg);
                    return;
                }
            })
        }
    }
};
</script>
<style lang="scss" scoped>
.globalPage {
    height: 100%;
    position: relative;
    background: #060327;
    padding-bottom: 15px;
}
.gp_header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    padding: 0 10px;
    .gp_header_main {
        height: 100%;
        background: url('../../assets/img/globalPage/gp_top_bg1.png') no-repeat;
        background-size: 100% 100%;
        .left_header {
            float: left;
            width: 34%;
            .user_info {
                float: left;
                padding-top: 15px;
                padding-left: 5%;
                .user_welcome {
                    float: left;
                    padding-left: 5px;
                    font-size: 16px;
                    line-height: 30px;
                    color: #00b7ff;
                    letter-spacing: 2px;
                    max-width: 180px;
                    height: 30px;
                    overflow: hidden;
                }
                .user_logout {
                    float: left;
                    border: 1px solid #0a7199;
                    text-align: center;
                    padding: 3px;
                    border-radius: 5px;
                    margin-left: 20px;
                    .logout_btn {
                        width: 76px;
                        padding: 5px 15px;
                        background: #00acde;
                        color: #fff;
                        border: none;
                    }
                }
            }
            .date_info {
                float: left;
                margin-left: 100px;
                width: 136px;
                height: 30px;
                margin-top: 15px;
                background: url(../../assets/img/globalPage/date_bj1.png) no-repeat;
                background-size: 100% 100%;
                padding-left: 15px;
                .date_now {
                    font-size: 12px;
                    line-height: 30px;
                    color: #00b7ff;
                }
            }
        }
        .center_title {
            float: left;
            width: 32%;
            p {
                font-size: 22px;
                text-align: center;
                cursor: pointer;
                color: #fff;
                letter-spacing: 6px;
                line-height: 13px;
                text-shadow: #0a7199 2px 0 0, #0a7199 0 2px 0, #0a7199 -2px 0 0, #0a7199 0 -2px 0;
            }
        }
    }
}
.gp_body {
    height: 100%;
    padding: 100px 10px 0 10px;
    .ct_section {
        width: 100%;
        height: 100%;
        padding-left: 1vw;
        padding-right: 2vw;
        padding-bottom: 1vw;
        .ct_section_main {
            position: relative;
            width: 100%;
            height: 100%;
            .ct_title_globalPage {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                .title_syItem {
                    float: left;
                    color: #fff;
                    line-height: 40px;
                    height: 40px;
                    font-size: 16px;
                }
                .btnBox_syItem {
                    float: right;
                    margin-top: 6px;
                    .btn__syItem {
                    }
                }
            }
            .ct_content_globalPage {
                padding-top: 40px;
                width: 100%;
                height: 100%;
                .echarts_dom {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .gp_body_top {
        height: 70%;
        padding-bottom: 20px;
        .map_section {
            float: left;
            width: 46.71%;
            height: 100%;
            background: url(../../assets/img/globalPage/item_bg1.png) no-repeat;
            background-size: 100% 100%;
            .ct_section {
                margin-top: -0.5vw;
                padding-bottom: 0.5vw;
            }
        }
        .right_mix_section {
            float: left;
            width: 53.29%;
            height: 100%;
            padding-left: 1.04vw;
            .top_mix_section {
                height: 50%;
                background: url(../../assets/img/globalPage/item_bg3.png) no-repeat;
                background-size: 100% 100%;
                .deviceState_section {
                    float: left;
                    width: 50%;
                    height: 100%;
                }
                .totalCapacity_section {
                    float: left;
                    width: 50%;
                    height: 100%;
                }
            }
            .botm_mix_section {
                height: 50%;
                padding-top: 20px;
                .totalOnTime_section {
                    float: left;
                    width: 50%;
                    height: 100%;
                    background: url(../../assets/img/globalPage/item_bg4.png) no-repeat;
                    background-size: 100% 100%;
                }
                .maintenanceOrder_section {
                    float: left;
                    width: 50%;
                    height: 100%;
                    padding-left: 20px;
                    .maintenanceOrder_section_main {
                        width: 100%;
                        height: 100%;
                        background: url(../../assets/img/globalPage/item_bg4.png) no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }
    .gp_body_botm {
        height: 30%;
        .projectList_section {
            float: left;
            width: 46.71%;
            height: 100%;
            background: url(../../assets/img/globalPage/item_bg4.png) no-repeat;
            background-size: 100% 100%;
        }
        .projectList_sectionLongBg{
            background: url(../../assets/img/globalPage/item_bg6.png) no-repeat;
            background-size: 100% 100%;
        }

        .alarm_section {
            float: left;
            width: 53.29%;
            height: 100%;
            padding-left: 1.04vw;
            .ct_section {
                background: url(../../assets/img/globalPage/item_bg4.png) no-repeat;
                background-size: 100% 100%;
            }
            .ct_sectionBg{
                background: url(../../assets/img/globalPage/item_bg6.png) no-repeat;
                background-size: 100% 100%;
            }
        }
        .top_Statistics {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 40px;
            color: #fff;
            .top_Statistics_main {
                float: right;
                height: 100%;
                display: flex;
                .statisticsInfo_box {
                    display: inline-block;
                    height: 100%;
                    .statisticsInfo_box_item {
                        display: inline-block;
                        line-height: 40px;
                        margin-right: 15px;
                    }
                }
                .selectBox {
                    display: inline-block;
                    height: 100%;
                    .select_globalPage {
                        width: 90px;
                        margin-top: 6px;
                    }
                }
            }
        }
    }
    .table_globalPage {
        background: none;
        color: #fff;
        // 设备状态的3种样式：在线、离线、报警
        .deviceState {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
        }
        .deviceStateText {
            display: inline-block;
            margin-left: 10px;
        }
        .deviceState0 {
            background: #8a8a8a;
        }
        .deviceState1 {
            background: #1afa29;
        }
        .deviceState2 {
            background: #ff0000;
        }
    }
}
.dialog_container {
}
@media screen and (max-width: 1700px) {
    .gp_header {
        .gp_header_main {
            .left_header {
                .date_info {
                    float: right;
                    margin-left: 0px;
                }
            }
        }
    }
}
@media screen and (max-width: 1360px) {
    .gp_header {
        .gp_header_main {
            .left_header {
                .user_info {
                    .user_welcome {
                        max-width: 150px;
                    }
                    .user_logout {
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
.globalPage {
    div {
        box-sizing: border-box;
    }
}
.globalPage {
    box-sizing: border-box;
}
.gp_body {
    .table_globalPage {
        tr,
        th {
            background-color: transparent;
        }
    }
    .el-table::before {
        background-color: transparent;
    }
    .el-table th.is-leaf,
    .el-table td {
        border-bottom: 1px solid transparent;
    }
    .el-table th > .cell {
        font-size: 14px;
        color: #00c5fe;
    }
    .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: transparent;
    }
}
.dialog_container {
    .fullScreenMap {
        .el-dialog__header {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
        }
        .el-dialog--center .el-dialog__body {
            padding: 0;
            padding-top: 55px;
            margin-top: 0;
            width: 100%;
            height: 100%;
        }
    }
}
.mapbox {
    width: 100%;
    height: 100%;
    position: relative;
    .mapbox_main {
        height: 100%;
        position: relative;
        /* 地图相关 */
        .mapDom {
            width: 100%;
            height: 100%;
            overflow: hidden;
            position: relative;
            font-family: '微软雅黑';
            border-radius: 10px;
            .h3 {
                padding: 0;
                margin: 0;
            }
            /* 去除百度标识 */
            .anchorBL {
                display: none;
            }
        }
    }
    .deviceInfoLayer {
        position: absolute;
        font-size: 13px;
        top: 10px;
        right: 10px;
        color: white;
        width: 440px;
        height: 330px;
        opacity: 0.75;
        background: black;
        border-radius: 5px;
        overflow: auto;
        text-align: center;
        box-sizing: border-box;
        .titleDeviceInfo {
            margin-top: 10px;
            margin-bottom: 10px;
            .paneltitle {
                font-size: 18px;
            }
        }
        .deviceInfoMain {
            float: left;
            padding: 10px;
            .wgdzxx {
                float: left;
                height: 236px;
                overflow-y: auto;
            }
            .class2 {
                float: left;
                margin-left: 5px;
                margin-top: 10px;
            }
            .class00 {
                float: left;
            }
            .class01 {
                width: 50px;
            }
            .class02 {
                width: 85px;
            }
            .class03 {
                width: 85px;
            }
            .class04 {
                width: 60px;
            }
            .class05 {
                width: 85px;
            }
        }
    }

    .BMap_scaleCtrl {
        div.BMap_scaleTxt {
            color: #fff !important;
        }
    }
}
.progress {
    border: 1px solid #0a7199;
    border-radius: 11px;
    height: 14px;
    box-sizing: border-box;
    position: relative;
    padding: 2px;
    span {
        height: 100%;
        display: inline-block;
        position: absolute;
        left: 2px;
        top: 2px;
        background: linear-gradient(to right, #073547, #1b98bd);
        height: 8px;
        border-radius: 11px;
    }
}
// .progress1{
//     span{background: linear-gradient(to right, #852ED5, #CD99FD);}
// }
// .progress2{
//     span{background: linear-gradient(to right, #073547, #1b98bd);}
// }
.ct_flex {
    flex-direction: column;
    .oneLineProgress {
        width: 100%;
        flex:1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .lineTxt,.progress  {
            width: 100%
        }
    }
    .progress {
        margin-top: 5px;
    }
}
.circleBox {
    .oneLine {
        margin-left: 30%;
        width: 60%;
        margin-top: -9vh;
    }
    .oneBox {
        width: 11.5vh;
        height: 11.5vh;
        background: url('../../assets/img/globalPage/circle011.png') no-repeat;
        background-size: 100%;
        b {
            font-size: 16px;
        }
    }
    .twoLine {
        width: 80%;
        margin: 3vh auto 0;
    }
    .twoLineBox {
        width: 13.25vh;
        height: 13.25vh;
        background: url('../../assets/img/globalPage/circle011.png') no-repeat;
        background-size: 100%;
    }
    .alarmBox {
        background: url('../../assets/img/globalPage/circle012.png') no-repeat;
        background-size: 100%;
        margin: 0 0 0 30%;
    }
    .faultBox {
        background: url('../../assets/img/globalPage/circle013.png') no-repeat;
        background-size: 100%;
    }
    .runBox {
        background: url('../../assets/img/globalPage/circle01.png') no-repeat;
        background-size: 100%;
    }
    .awaitBox {
        background: url('../../assets/img/globalPage/circle01.png') no-repeat;
        background-size: 100%;
    }
}
.oneLineTwo{
    .oneBox {margin:  0 10%;}
    .alarmBox {
        margin: 0 0 0 26%;position: relative;z-index: 144;cursor: pointer;

    }
}
#monthEcharts{
  width: 100%;height: 100%;
}
.tableScroll{height: calc(100% - 36px);overflow: hidden;
    .listScroll{
        padding-left: 10px;padding-right: 10px;line-height:25px;
        span{width:20%;display: inline-block;text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
    }
    
}
.listThead{
        span{width:20%;display: inline-block;text-align: center;}
    }
</style>
